import { useState } from 'react';
import { ParcellingPage } from '@practium/features/parcelling';
import { useAuth } from '@practium/features/auth';
import { UserRole } from '@practium/shared';
import { usePermissions } from '@practium/features/permissions';
import { useForBinding } from '@practium/features/forBinding';
import { useParcellingPageClient } from '../hooks/useParcellingPageClient';

const PARCELLING_PAGE_SIZE = 15;

export const ParcellingPageClient = () => {
	const { user } = useAuth();
	const [listPage, setListPage] = useState(1);
	const { isForBinding, forBindingUser, forBindingUserLevel, forBindingId } = useForBinding();
	const { abilities } = usePermissions();

	const userRole = user?.role || UserRole.Farmer;
	const isMaster = isForBinding ? false : (user?.isMaster ?? false);
	const currentUserId = isForBinding ? (forBindingUser?._id ?? '') : (user?._id || '');

	const canRead = abilities.can('read', 'parcelling');
	const canCreate = abilities.can('create', 'parcelling');
	const canEdit = abilities.can('update', 'parcelling');
	const canDelete = abilities.can('delete', 'parcelling');

	const permissions = {
		canView: canRead,
		canCreate,
		canEdit,
		canDelete,
		canDuplicate: canEdit,
		canExport: canRead,
	};

	const { mockData, fetchFarms, fetchBindingUsers, effectiveRole, autoSelectSelfAsClient } = useParcellingPageClient({
		userRole,
		isForBinding,
		forBindingUserLevel,
		forBindingId: forBindingId ?? undefined,
		effectiveUserId: currentUserId || undefined,
		forBindingUser,
		canRead,
		page: listPage,
		limit: PARCELLING_PAGE_SIZE,
	});

	return (
		<ParcellingPage
			config={{
				permissions,
				mockData,
				userRole: effectiveRole,
				currentUserId,
				isMaster,
				autoSelectSelfAsClient,
			}}
			page={listPage}
			onPageChange={setListPage}
			fetchBindingUsers={fetchBindingUsers}
			fetchFarms={fetchFarms}
		/>
	);
};
